/** @format */
import ModalTemplate from '../../../../../../../Components/ModalTemplate/ModalTemplate'
import localize from '../../../../../../../Global/Localize'
import React, { useState } from 'react'
import {  putData } from '../../../../../../../Helpers/webApi'
import swal from 'sweetalert2'
import { ApproveRequisitionModal } from './ApproveRequisitionModal'
import EnumsServerCombo from '../../../../../../../Components/ComboBox/EnumsServerCombo'

function RequisitionModal({
  mode,
  onHideModal,
  loading,
  onUpdateRefreshAt,
  onSetMode,
  selectedRequisition,
  setSelectedRequisition,
}) {
  const [isBusy, setIsBusy] = useState(false)

  async function handleSubmit() {
    if (mode === 'approve') {
      approveRequisition()
    }
  }

  const approveRequisition = async () => {
    setIsBusy(true)
    const { success, data } = await putData(
      '/WorkFlow/approve-requisition-workflow-item',
      {
        ...selectedRequisition,
      },
      false,
    )
    if (success) {
      onSetMode(null)
      onUpdateRefreshAt()
      setSelectedRequisition(null)
      swal.fire(
        'Approve Requisition',
        'Operation Completed Successfully',
        'success',
      )
    }
    setIsBusy(false)
  }

  return (
    <>
      <>
        {mode && (
          <ModalTemplate
            modalMode={mode}
            modalTitle={localize('requisition')}
            handleAction={handleSubmit}
            handleClose={onHideModal}
            footerChildren={
              <div className="d-flex align-content-end justify-content-end">
                <div className="col d-flex align-items-center me-5">
                  <label className="col-3 text-capitalize me-4">
                    {localize('remarks')}
                  </label>
                  <input
                    className="form-control"
                    value={selectedRequisition?.remarks}
                    onChange={e => {
                      setSelectedRequisition({
                        ...selectedRequisition,
                        remarks: e.target.value,
                      })
                    }}
                  />
                </div>
                <div className="col d-flex align-items-center ms-2">
                  <EnumsServerCombo
                    value={selectedRequisition?.approvalOption}
                    onChange={e => {
                      setSelectedRequisition({
                        ...selectedRequisition,
                        approvalOption: e.value,
                      })
                    }}
                    customContainerStyle={{ width: '100%' }}
                    enumsKey="WorkflowApprovalOption"
                  />
                </div>
              </div>
            }
            hideUpdate={mode === 'view'}
            disableCreate={isBusy}
            modalClassName={'modal-xl'}
          >
            {mode === 'approve' && (
              <ApproveRequisitionModal
                isBusy={loading || isBusy}
                selectedRequisition={selectedRequisition}
              />
            )}
          </ModalTemplate>
        )}
      </>
    </>
  )
}

export default RequisitionModal
